module.exports = __webpack_public_path__ + "static/media/zh-CN.87d6c351.svg";